import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ConfirmationModal from "../../Common/ConfirmationModal";
import Tag from "sushiweb/Tag";
import Button from "sushiweb/Button";
import AddEdit from "sushiweb/Icons/all/AddEdit";
import Delete from "sushiweb/Icons/all/Delete";
import Plus from "sushiweb/Icons/all/Plus";
import * as UserActions from "../../../store/actions/User";
import { makeStyles } from "@material-ui/core";
import grey from "sushiweb/tokens/color/grey";
import green from "sushiweb/tokens/color/green";
import black from "sushiweb/tokens/color/black";
import red from "sushiweb/tokens/color/red";
import LevelFormModal from "../EditLevelFormModal";
import AddLevelFormModal from "../AddLevelFormModal";
import EditRuleFormModal from "../EditRuleFormModal";
import commonStyles from "../../../static/styles/common";
import TableFields from "../../../constants/RuleList/TableFields.json";
import { getPath, isEmpty } from "../../../utils";
import BlankState from "../../Common/BlankState";
import * as CityPropertyActions from "../../../store/actions/CityProperty";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import ContainerGrid from "sushiweb/ContainerGrid";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import Copy from "sushiweb/Icons/all/Copy";
import Table from "../../Common/Table";

const useStyles = makeStyles((theme) => ({
  ...commonStyles.tableListStyles,
  table: {
    padding: theme.spacing(30),
  },
  button: {
    margin: theme.spacing(1),
    width: 100,
    height: 30,
    class: "shushi-btn",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  fieldsMargin: {
    margin: "1.25rem 0",
    width: 250,
  },
  switch: {
    margin: theme.spacing(1),
    totalWidth: "60px",
    height: 30,
  },
  tag: {
    margin: theme.spacing(1),
    height: 30,
  },
  ismodified: {
    margin: theme.spacing(1),
  },
}));

const GenSettingList = (props) => {
  const classes = useStyles();
  const [activeRule, setActiveRule] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [activeDeleteRule, setActiveDeleteRule] = useState({});
  const {
    finalConfig,
    activeCityProperty,
    activeGenSetting,
    setSelectedCity,
    createdRule,
  } = props;

  useEffect(() => {
    setActiveRule(null);
  }, [finalConfig]);

  const handleClick = (type, rule) => {
    let newRule = JSON.parse(JSON.stringify(rule));
    setActiveRule(newRule);
    setModalState(type);
  };

  const confirmModalOpenHandler = (rule) => {
    setActiveDeleteRule(rule);
    setConfirmModalOpen(true);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
    setActiveDeleteRule({});
  };

  const copyRuleHandler = (rule) => {
    if (activeCityProperty.value.rules != undefined) {
      activeCityProperty.value.rules.push(rule);
    } else {
      activeCityProperty.value.rules = [rule];
    }

    props
      .getFinalConfig(activeCityProperty, activeGenSetting)
      .then((finalConfig) => {
        props.setFinalConfig(finalConfig);
      });
  };

  const deleteRuleHandler = () => {
    let ruleFound = false;

    if (!isEmpty(createdRule) && activeDeleteRule.is_new != undefined) {
      props.resetStateGenSetting({ state: "activeRule" });
    }
    // check if that rule was inherited from city_property
    else if (
      !isEmpty(activeCityProperty) &&
      activeCityProperty.value.rules != undefined
    ) {
      activeCityProperty.value.rules.map((rule) => {
        if (
          activeDeleteRule.is_city_property &&
          rule.rule_name == activeDeleteRule.rule_name
        ) {
          ruleFound = true;
        }
      });
      if (ruleFound) {
        let cityProperty = activeCityProperty.value.rules.filter(
          (rule) => rule.rule_name != activeDeleteRule.rule_name
        );
        activeCityProperty.value.rules = cityProperty;
        props.setActiveCityProperty(activeCityProperty);
        props
          .getFinalConfig(activeCityProperty, activeGenSetting)
          .then((res) => {
            props.resetStateGenSetting({ state: "finalConfig" });
            props.setFinalConfig(res);
          });
      }
    }
    //if rule is from general setting then delete it and update the gs and load final config
    if (!ruleFound) {
      let genSetting = activeGenSetting.value.rules.filter(
        (rule) => rule.rule_name != activeDeleteRule.rule_name
      );
      activeGenSetting.value.rules = genSetting;
      props.setActiveGenSetting(activeGenSetting);
      props.getFinalConfig(activeCityProperty, activeGenSetting).then((res) => {
        props.resetStateGenSetting({ state: "finalConfig" });
        props.setFinalConfig(res);
      });
    }
    confirmModalCloseHandler();
  };

  const handleModalClose = () => {
    setActiveRule(null);
    setModalState(false);
  };

  //return a different colour if rule was inherited from city property
  const getColor = (rule) => {
    if (rule.is_city_property != undefined && rule.is_city_property) {
      return "Linen";
    }
    return "";
  };

  const getModal = () => {
    switch (modalState) {
      case "EditLevel":
        return (
          <LevelFormModal
            activeRule={activeRule}
            setActiveRule={setActiveRule}
            modalState={modalState}
            handleModalClose={handleModalClose}
          />
        );
      case "AddLevel":
        return (
          <AddLevelFormModal
            activeRule={activeRule}
            setActiveRule={setActiveRule}
            modalState={modalState}
            handleModalClose={handleModalClose}
          />
        );
      case "EditRule":
        return (
          <EditRuleFormModal
            handleModalClose={handleModalClose}
            modalState={modalState}
            heading="Edit Rule"
            activeRule={activeRule}
            setActiveRule={setActiveRule}
            activeCityProperty={activeCityProperty}
            activeGenSetting={activeGenSetting}
            getFieldValue={getFieldValue}
          />
        );
    }
  };

  const getFieldValue = (rule, key, idx) => {
    let newRule = JSON.parse(JSON.stringify(rule));
    const style = {
      color: "black",
      fontWeight: "normal",
    };
    if (newRule.is_city_property != undefined && rule.is_city_property) {
      style.color = "green";
      style.fontWeight = "bold";
    }

    switch (key) {
      case "priority":
        let priority = undefined;
        if (newRule[key]) {
          priority = newRule[key];
        }
        return <p style={style}>{priority}</p>;
      case "rule_name":
        let rule_name = "";
        if (newRule[key]) {
          rule_name = newRule[key];
        }
        return <p style={style}>{rule_name}</p>;
      case "levels":
        let length = 0;
        if (newRule[key] && Array.isArray(newRule[key])) {
          length = newRule[key].length;
        }
        return <p style={style}>{length}</p>;
      case "order_selector":
        let bColor =
          rule.is_city_property != undefined && rule.is_city_property
            ? "#FAF0E6"
            : "#00000000";
        if (rule[key] == undefined) {
          rule[key] = {};
        }
        if (rule[key]) {
          return (
            <JSONInput
              id={String(key)}
              placeholder={rule[key]}
              locale={locale}
              height="auto"
              width="auto  "
              viewOnly={true}
              colors={{
                string: "#FA7921",
                number: "#50B547",
                background: bColor,
                keys: "#1E1E1E",
                default: black,
              }}
              confirmGood={false}
              theme="light_mitsuketa_tribute"
            />
          );
        }
      case "inherited_from":
        const label =
          rule.is_city_property != undefined && rule.is_city_property
            ? "CP"
            : "GS";
        const bgColor =
          rule.is_city_property != undefined && rule.is_city_property
            ? green.z500
            : grey.z500;
        return (
          <div className={classes.actionsSpacing}>
            {/* <Switch type="default" className={classes.switch} 
            onToggle={(flag)=>{copyRuleHandler(flag,rule);}}
            alignVertical="center"
            active={label == "CP"}
            readOnly={isEmpty(activeCityProperty) || label == "CP"}
            color={bgColor}
          /> */}
            <Tag
              type="tag"
              tagWidth="55px"
              className={classes.tag}
              label={label}
              bgColor={bgColor}
            ></Tag>
          </div>
        );
      case "is_modified":
        const label_ =
          rule.is_modified != undefined && rule.is_modified ? "Yes" : "No";
        const bgColor_ =
          rule.is_modified != undefined && rule.is_modified
            ? red.z500
            : grey.z500;
        return (
          <Tag
            type="tag"
            className={classes.tag}
            label={label_}
            tagWidth="55px"
            bgColor={bgColor_}
          ></Tag>
        );
      case "actions":
        return (
          <ContainerGrid
            className={classes.actionsSpacing}
            columns="1 1"
            tabletColumns="1 1"
            mobileColumns="1 1"
          >
            <div class="box">
              {" "}
              <Button
                className={classes.button}
                icon={<AddEdit />}
                onClick={() => handleClick("EditLevel", newRule)}
                size="small"
                appearance="outline"
              >
                Levels
              </Button>{" "}
            </div>
            <div class="box">
              {" "}
              <Button
                className={classes.button}
                icon={<Plus />}
                onClick={() => handleClick("AddLevel", newRule)}
                size="small"
                appearance="outline"
              >
                Level
              </Button>{" "}
            </div>
            <div class="box">
              {" "}
              <Button
                className={classes.button}
                icon={<AddEdit />}
                onClick={() => handleClick("EditRule", newRule)}
                pill
                size="small"
                appearance="outline"
              >
                Rule
              </Button>{" "}
            </div>
            <div class="box">
              {!isEmpty(activeCityProperty) &&
              (rule.is_city_property == undefined || !rule.is_city_property) ? (
                <>
                  <Button
                    onClick={() => copyRuleHandler(newRule)}
                    icon={<Copy />}
                    className={classes.button}
                    size="small"
                    appearance="outline"
                  >
                    Copy
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    disabled={
                      !isEmpty(activeCityProperty) &&
                      (rule.is_city_property == undefined ||
                        !rule.is_city_property)
                    }
                    onClick={() => confirmModalOpenHandler(newRule)}
                    icon={<Delete />}
                    appearance="outline"
                    className={classes.button}
                    size="small"
                  >
                    Delete
                  </Button>
                </>
              )}
            </div>
          </ContainerGrid>
        );
      default:
        return newRule[key];
    }
  };

  return (
    <div className="General-Setting-List-Container">
      <Table
        list={finalConfig}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      <ConfirmationModal
        open={confirmModalOpen}
        modalTitle="Delete Rule"
        onCofirmCancelHandler={confirmModalCloseHandler}
        onCofirmSuccessHandler={deleteRuleHandler}
        successButtonText="delete"
        successButtonColor="secondary"
      >
        {`Are you sure to delete ${activeDeleteRule.rule_name} Rule?`}
      </ConfirmationModal>{" "}
      {!!modalState && getModal()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { CityProperty, GenSetting } = state;
  return {
    activeCityProperty: CityProperty.activeCityProperty,
    activeGenSetting: GenSetting.activeGenSetting,
    finalConfig: GenSetting.finalConfig,
    createdRule: GenSetting.activeRule,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGenSettingRule: bindActionCreators(
      GenSettingActions.getGenSettingRule,
      dispatch
    ),
    resetStateGenSetting: bindActionCreators(
      GenSettingActions.resetState,
      dispatch
    ),
    resetStateCityProperty: bindActionCreators(
      CityPropertyActions.resetState,
      dispatch
    ),
    getFinalConfig: bindActionCreators(
      GenSettingActions.getFinalConfig,
      dispatch
    ),
    setFinalConfig: bindActionCreators(
      GenSettingActions.setFinalConfig,
      dispatch
    ),
    setActiveGenSetting: bindActionCreators(
      GenSettingActions.setActiveGenSetting,
      dispatch
    ),
    setActiveCityProperty: bindActionCreators(
      CityPropertyActions.setActiveCityProperty,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenSettingList);
